import styleHeader from "./Header.module.css";
import logo from "../../assets/img/logo.png";
import manMask from "../../assets/img/manMask.png";
import { useNavigate, Link, useLocation } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../../contexts/AuthProvider";
import UseAuth from "../../hooks/UseAuth";
import Cookies from "js-cookie";
import { logout } from "../../adapters/apis/auth/auth";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import { getListNotifications } from "../../adapters/apis/notifications/notifications";

const Header = () => {
  //assigning location variable
  const location = useLocation();
  const { t } = useTranslation();
  //destructuring pathname from location
  const { pathname } = location;

  //Javascript split method to get the name of the path in array
  const splitLocation = pathname.split("/");

  const { setAuth } = useContext(AuthContext);
  const { auth } = UseAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState(auth.full_name);

  // Notification badge
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!auth.isAuth) return;

    const fetchUnread = async () => {
      try {
        const res = await getListNotifications(1);
        setUnreadCount(res.data.unread_count ?? 0);
      } catch (err) {
        console.error("Failed to fetch notification count", err);
      }
    };

    fetchUnread();
  }, [auth.isAuth]);

  const handleLogout = async () => {
    try {
      await logout();
      setAuth({});
      Cookies.remove("auth-token");
      Cookies.remove("user-name");
      Cookies.remove("refresh-token");
      // Cookies.remove("phone_verified");
      // Cookies.remove("ocr_verified");
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
      Cookies.remove("auth-token");
      Cookies.remove("user-name");
      Cookies.remove("refresh-token");
      // Cookies.remove("phone_verified");
      // Cookies.remove("ocr_verified");
      window.location.href = "/login";
    }
  };

  useEffect(() => {
    setUsername(auth.full_name);
  }, [auth.full_name]);

  const handlecolapse = () => {
    const nav = document.querySelector(".navbar-collapse");
    if (nav) nav.classList.toggle("collapse");
  };

  // 🔵 Optional: show current language (ar/en)
  const currentLng = i18n.language?.startsWith("ar") ? "ar" : "en";

  return (
    <section className={styleHeader.header}>
      <nav
        className={`${styleHeader["navbar"]} navbar navbar-expand-lg fixed-top`}
      >
        <div className={`${styleHeader["big-padding"]} container-fluid`}>
          <Link
            className="navbar-brand d-flex align-items-center text-center gap-2"
            to="/home"
          >
            <img
              src={logo}
              alt="logo"
              width="40"
              height="40"
              className={styleHeader["logo-header"]}
            />
            <h4 className={`${styleHeader["logo-title"]} fw-bolder mb-0 fs-6`}>
              {/* You can translate these heading lines too if you prefer */}
              وزارة المالية
              <p className="d-blok mb-0">مصلحة الضرائب العقارية</p>
            </h4>
          </Link>

          <div className="d-flex align-items-center order-lg-2">
            {/*  <div
              className="btn-group me-2"
              role="group"
              aria-label="Language switcher"
            >
              <button
                type="button"
                onClick={() => i18n.changeLanguage("ar")}
                className={`btn btn-sm ${currentLng === "ar" ? "btn-primary" : "btn-outline-primary"}`}
                title="العربية"
              >
                ع
              </button>
              <button
                type="button"
                onClick={() => i18n.changeLanguage("en")}
                className={`btn btn-sm ${currentLng === "en" ? "btn-secondary" : "btn-outline-secondary"}`}
                title="English"
              >
                En
              </button>
            </div>
*/}
            <button
              className="navbar-toggler"
              onClick={handlecolapse}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="true"
              aria-label="Toggle navigation"
              style={{ border: "none" }}
            >
              <span
                style={{ color: "#009EF7" }}
                className="navbar-toggler-icon"
              ></span>
            </button>
          </div>

          <div
            className="collapse navbar-collapse order-lg-1"
            id="navbarSupportedContent"
          >
            {auth.isAuth ? (
              <div
                className={`${styleHeader.myProfile_parent}
              d-lg-none d-block
              `}
              >
                <Link
                  className={`${styleHeader.myProfile} 
                `}
                  to="/user-settings"
                >
                  <div
                    className={`${styleHeader["info-text"]}
                  d-flex align-items-center gap-3 mb-3
                  `}
                  >
                    <p className={`${styleHeader.welcomeTop} mb-0`}>اهلا بك</p>
                    <p className={`${styleHeader["user-name-text-top"]} mb-0`}>
                      {username}
                    </p>
                  </div>
                </Link>
              </div>
            ) : (
              ""
            )}

            <ul
              className={
                auth.isAuth
                  ? `${styleHeader["navbar-nav"]} navbar-nav m-auto  mb-1`
                  : `${styleHeader["navbar-nav"]} navbar-nav mb-1`
              }
              ref={(node) => {
                if (node) {
                  node.style.setProperty("margin-right", "auto", "important");
                }
              }}
            >
              <li
                className={`${styleHeader["nav-item"]} nav-item`}
                onClick={() => {
                  // if (location.pathname === "/tax-declaration/list-data") {
                  // window.location.reload();
                  // }
                }}
              >
                <Link
                  // className={
                  //   location.pathname === "/tax-declaration/list-data"
                  //     ? `${styleHeader["active"]}  ${styleHeader["nav-link"]} nav-link`
                  //     : `${styleHeader["nav-link"]} nav-link`
                  // }
                  className={
                    splitLocation[1] === "tax-declaration"
                      ? `${styleHeader["active"]}  ${styleHeader["nav-link"]} nav-link`
                      : `${styleHeader["nav-link"]} nav-link`
                  }
                  to="/tax-declaration/list-data"
                >
                  {t("navbar.tax_decleration", "الإقرار الضريبي")}
                </Link>
              </li>

              <li
                className={`${styleHeader["nav-item"]} nav-item`}
                onClick={() => {
                  // if (location.pathname === "/settlement-account-debt") {
                  // window.location.reload();
                  // }
                }}
              >
                <Link
                  className={
                    location.pathname === "/settlement-account-debt"
                      ? `${styleHeader["active"]}  ${styleHeader["nav-link"]} nav-link`
                      : `${styleHeader["nav-link"]} nav-link`
                  }
                  to="/settlement-account-debt"
                >
                  {t("navbar.claim_payments", "سداد مديونيات بعلم المكلف")}
                </Link>
              </li>

              <li
                className={`${styleHeader["nav-item"]} nav-item`}
                onClick={() => {
                  // if (location.pathname === "/my-debts") {
                  // window.location.reload();
                  // }
                }}
              >
                <Link
                  className={
                    location.pathname === "/my-debts"
                      ? `${styleHeader["active"]}  ${styleHeader["nav-link"]} nav-link`
                      : `${styleHeader["nav-link"]} nav-link`
                  }
                  to="/my-debts"
                >
                  {t("navbar.my_debts", "مديونياتي")}
                </Link>
              </li>

              <li
                className={`${styleHeader["nav-item"]} nav-item`}
                onClick={() => {
                  // if (location.pathname === "/online-payment/list-payment") {
                  // window.location.reload();
                  // }
                }}
              >
                <Link
                  id="online-payment-link"
                  className={
                    location.pathname === "/coming-soon" &&
                    new URLSearchParams(location.search).get("s") === "payment"
                      ? `${styleHeader["active"]} ${styleHeader["nav-link"]} nav-link`
                      : `${styleHeader["nav-link"]} nav-link`
                  }
                  // className={
                  //   splitLocation[1] === "online-payment" ||
                  //     splitLocation[1] === "online-payment/confirm"
                  //     ? `${styleHeader["active"]}  ${styleHeader["nav-link"]} nav-link`
                  //     : `${styleHeader["nav-link"]} nav-link`
                  // }
                  // to="/online-payment/list-payment"
                  to="/coming-soon?s=payment"
                >
                  {/* Replace with t() when you add the key */}
                  {t(
                    "navbar.online_payment",
                    "الدفع الإلكتروني للوحدات المميكنة",
                  )}
                </Link>
              </li>
              {/* 
              <li className={`${styleHeader["nav-item"]} nav-item`}>
                <Link
                  className={
                    splitLocation[1] === "coming-soon"
                      ? `${styleHeader["active"]}  ${styleHeader["nav-link"]} nav-link`
                      : `${styleHeader["nav-link"]} nav-link`
                  }
                  to="/coming-soon"
                >
                  {t("navbar.official_statement", "الكشف الرسمى")}
                </Link>
              </li>

              <li className={`${styleHeader["nav-item"]} nav-item`}>
                <Link
                  className={
                    splitLocation[1] === "coming-soon"
                      ? `${styleHeader["active"]}  ${styleHeader["nav-link"]} nav-link`
                      : `${styleHeader["nav-link"]} nav-link`
                  }
                  to="/coming-soon"
                >
                  {t("navbar.tax_exemption", "الإعفاء الضريبى")}
                </Link>
              </li>

              <li
                className={`${styleHeader["nav-item"]} nav-item`}
                onClick={() => {
                  if (location.pathname === "/tax-appeal/list-data") {
                    window.location.reload();
                  }
                }}
              >
                <Link
                  className={
                    splitLocation[1] === "tax-appeal"
                      ? `${styleHeader["active"]} ${styleHeader["nav-link"]} nav-link`
                      : `${styleHeader["nav-link"]} nav-link`
                  }
                  to="/tax-appeal/list-data"
                >
                  {t("navbar.tax_appeal", "الطعن الضريبى")}
                </Link>
              </li> */}
              <li
                className={`${styleHeader["nav-item"]} nav-item`}
                onClick={() => {
                  if (location.pathname === "/tax-appeal/list-data") {
                    // window.location.reload();
                  }
                }}
              >
                <Link
                  // className={
                  //   splitLocation[1] === "tax-appeal"
                  //     ? `${styleHeader["active"]} ${styleHeader["nav-link"]} nav-link`
                  //     : `${styleHeader["nav-link"]} nav-link`
                  // }

                  className={
                    location.pathname === "/coming-soon" &&
                    new URLSearchParams(location.search).get("s") === "appeal"
                      ? `${styleHeader["active"]} ${styleHeader["nav-link"]} nav-link`
                      : `${styleHeader["nav-link"]} nav-link`
                  }
                  to="/coming-soon?s=appeal"
                >
                  {t("navbar.tax_appeal", "الطعن الضريبى")}
                </Link>
              </li>

              <li
                className={`${styleHeader["nav-item"]} nav-item`}
                onClick={() => {
                  // if (location.pathname === "/tax-dispute-request/list-data") {
                  // window.location.reload();
                  // }
                }}
              >
                <Link
                  // className={
                  //   splitLocation[1] === "tax-dispute-request" ||
                  //     splitLocation[1] === "tax-dispute"
                  //     ? `${styleHeader["active"]} ${styleHeader["nav-link"]} nav-link`
                  //     : `${styleHeader["nav-link"]} nav-link`
                  // }
                  // to="/tax-dispute-request/list-data"

                  className={
                    location.pathname === "/coming-soon" &&
                    new URLSearchParams(location.search).get("s") === "dispute"
                      ? `${styleHeader["active"]} ${styleHeader["nav-link"]} nav-link`
                      : `${styleHeader["nav-link"]} nav-link`
                  }
                  to="/coming-soon?s=dispute"
                >
                  {t("navbar.tax_dispute", "إنهاء المنازعات الضريبية")}
                </Link>
              </li>

              {/* <li className={`${styleHeader["nav-item"]} nav-item`}>
                <Link
                  className={
                    splitLocation[1] === "support"
                      ? `${styleHeader["active"]}  ${styleHeader["nav-link"]} nav-link`
                      : `${styleHeader["nav-link"]} nav-link`
                  }
                  to="/support"
                >
                  {t("navbar.support", "الدعم الفني")}
                </Link>
              </li> */}

              {auth.isAuth ? (
                <li
                  className={`${styleHeader["nav-item"]} nav-item d-lg-none d-block`}
                >
                  <Link
                    className={`${styleHeader["nav-link"]} nav-link`}
                    onClick={handleLogout}
                    to=""
                  >
                    {t("navbar.logout", "تسجيل خروج")}
                  </Link>
                </li>
              ) : (
                ""
              )}
            </ul>

            {auth.isAuth ? (
              <div
                className={`${styleHeader.myProfile_parent} d-none d-lg-flex align-items-center`}
              >
                <div
                  className={`${styleHeader.myProfile} d-flex justify-content-center align-items-center gap-3`}
                >
                  <Link
                    to="/notification/list"
                    className="rounded p-2 rounded-circle justify-items-center"
                    style={{ backgroundColor: "#FFDCDC" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                      aria-label={`${unreadCount} إشعارات غير مقروءة`}
                    >
                      {/* ── Part 1: Bell body (Shape-1.svg, 23.269×23.269) centred */}
                      <g transform="translate(6.366, 4)">
                        <path
                          d="M20.447,16.865c-.03,0-.059.005-.089.005A9.291,9.291,0,0,1,12.8,2.159V1.164a1.163,1.163,0,1,0-2.326,0V2.42a8.148,8.148,0,0,0-6.98,8.05v3.244A7.8,7.8,0,0,1,.712,19.686a2.036,2.036,0,0,0,1.325,3.583h19.2a2.036,2.036,0,0,0,1.314-3.592,7.783,7.783,0,0,1-2.1-2.813Z"
                          fill="#f02323"
                        />
                      </g>

                      {/* ── Part 2: Bottom arc / clapper (Shape.svg, 8.549×3.49) centred */}
                      <g transform="translate(13.726, 28.1)">
                        <path
                          d="M4.275,3.49A4.368,4.368,0,0,0,8.549,0H0A4.37,4.37,0,0,0,4.275,3.49Z"
                          fill="#f02323"
                        />
                      </g>

                      {/* ── Part 3: Badge circle (Shape-2.svg) – top-right corner */}
                      <g transform="translate(19, 3.5)">
                        {/* Circle background */}
                        <circle cx="7.5" cy="7.5" r="7.5" fill="#f02323" />
                        {/* Count text */}
                        <text
                          x="7.5"
                          y="11"
                          textAnchor="middle"
                          fill="white"
                          fontSize={unreadCount > 9 ? "7" : "9"}
                          fontWeight="bold"
                          fontFamily="Arial, sans-serif"
                        >
                          {unreadCount > 99 ? "99+" : unreadCount}
                        </text>
                      </g>
                    </svg>
                  </Link>
                  <Link
                    className={`${styleHeader.myProfile} d-flex justify-content-center align-items-center gap-3`}
                    to="/user-settings"
                  >
                    {" "}
                    <img src={manMask} alt="user-icon" width="50" height="50" />
                    <div className={styleHeader["info-text"]}>
                      <p className={`${styleHeader.welcome} mb-0`}>
                        {/* Replace with t() when you add the key */}
                        {t("header.welcome", "اهلا بك")}
                      </p>
                      <p className={`${styleHeader["user-name-text"]} mb-0`}>
                        {username}
                      </p>
                    </div>
                  </Link>
                </div>
                <Link
                  onClick={handleLogout}
                  to=""
                  className={styleHeader["btn-log-out"] + " fa-xl"}
                >
                  <li className="fa-solid fa-arrow-right-from-bracket fa-flip-horizontal mx-2 fa-lg"></li>
                  <span className="d-none d-xl-inline" id="logout_header">
                    {t("navbar.logout", "تسجيل الخروج")}
                  </span>
                </Link>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </nav>
    </section>
  );
};

export default Header;
